import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CheckboxComponent } from '@app/shared/components/checkbox/checkbox.component';
import { SelectableButtonComponent } from '@app/shared/components/selectable-button/selectable-button';
import { FirstPair } from '@infrastructure/firstPair.enum';
import { Gender } from '@infrastructure/gender.enum';
import { TranslatePipe } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-customizer-statistics',
    templateUrl: './customizer-statistics.component.html',
    styleUrls: ['./customizer-statistics.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe, SelectableButtonComponent, CheckboxComponent, CommonModule]
})
export class CustomizerStatisticsComponent {

	@Input() age: string;
	@Input() firstPair: FirstPair;
	@Input() gender: Gender;
	@Input() showMandatoryMessage: BehaviorSubject<boolean | null | undefined>;

	@Output() ageChange = new EventEmitter<string | null>();
	@Output() firstPairChange = new EventEmitter<FirstPair | null>();
	@Output() genderChange = new EventEmitter<Gender | null>();

	public ages = new Array<string>("0-9", "10-19", "20-29", "30-39", "40-49", "50-59", "60-69", "70-79", "80-89", "90-99", "100-109", "110-119");
	public genders = Gender;
	public firstPairs = FirstPair;
	public ageOptionsText = (age: string | null) => age ?? '';

	optionGroupHeaderVoid = () => {
		return;
	}



	constructor() { }

}
